import qs from 'querystring';
import xhr from '~/xhr';

const baseUrl = process.env.baseUrl;
const webloginBaseUrl = process.env.webloginBaseUrl;

// 适用于不需要判断code的接口
const doGet = (url, args) =>
  xhr
    .get(url, args)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
    });

export default {
  // 获取手机国家码列表
  getCountryInfoList: () => doGet(`${baseUrl}/OInterface/getCountryInfoList`),
  // 获取用户头像
  getUserInfo: () => xhr.get(`${baseUrl}/usercenter/getUserInfo`),
  // 获取游戏分类
  getGameCategory: () => doGet(`${baseUrl}/OInterface/getGameCategory`),
  // 获取游戏名与游戏id的映射
  getGameMap: () => doGet(`${baseUrl}/OInterface/getGameMap`),
  // 获取秀场直播房间
  getShowbizList: (data) =>
    doGet(`${baseUrl}/OInterfaceWeb/vedioList/5`, { params: data }),
  getGamingList: (data) =>
    doGet(`${baseUrl}/OInterfaceWeb/vedioList/11`, { params: data }),
  // 获取国家列表
  getRegionList: (data) =>
    doGet(`${baseUrl}/OInterface/getRegionList`, { params: data }),
  // 首页的收礼排行榜
  getWeekGetRank: () => doGet(`${baseUrl}/OInterface/getWeekGetRank`),
  // 首页的送礼排行榜
  getWeekSendRank: () => doGet(`${baseUrl}/OInterface/getWeekSendRank`),
  updateUserInfo: (data) =>
    xhr.post(`${baseUrl}/usercenter/uUserInfo`, qs.stringify(data)),
  updateAvatar: (data) => xhr.post(`${baseUrl}/usercenter/uAvatar`, data),
  // 获取首页banner背景
  getAd: (data) => doGet(`${baseUrl}/OInterface/getAd`, { params: data }),
  // 获取直播信息
  getInternalStudioInfo: (data) =>
    xhr.post(`${baseUrl}/studio/getInternalStudioInfo`, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }),
  getWebSocketLink: (data) =>
    xhr.post(`${baseUrl}/studio/getWebSocketLink`, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }),
  getOnlineGifts: (params) =>
    xhr.get(`${baseUrl}/live/giftconfig/getOnlineGifts`, { params }),
  // 检查用户ip
  checkIp: (data) => xhr.get(`${baseUrl}/OInterface/checkIp`, data),
  // 获取直播间用户信息
  getUserInfoStudio: (params) =>
    xhr.get(`${baseUrl}/OUserCenter/getUserInfoStudio`, { params }),
  // 二维码加载
  qrcode: (data) => xhr.post(`${webloginBaseUrl}/qrcode`, qs.stringify(data)),
  comet: (params) =>
    xhr.get(`${webloginBaseUrl}/comet`, { params }, { timeout: 20000 }),
  // 发送验证码
  sendCode: (data) =>
    xhr.post(`${webloginBaseUrl}/sendCode`, qs.stringify(data)),
  checkCode: (data) =>
    xhr.post(`${webloginBaseUrl}/checkCode`, qs.stringify(data)),
  login: (data) => xhr.post(`${webloginBaseUrl}/login`, qs.stringify(data)),
  logout: (data) => xhr.post(`${webloginBaseUrl}/logout`, qs.stringify(data)),
  updatePassword: (data) =>
    xhr.post(`${webloginBaseUrl}/updatePassword`, qs.stringify(data)),
  register: (data) =>
    xhr.post(`${webloginBaseUrl}/register`, qs.stringify(data)),
  directLogin: (data) =>
    xhr.post(`${webloginBaseUrl}/directLogin`, qs.stringify(data)),
  twLogin: (data) => xhr.post(`${webloginBaseUrl}/twLogin`, qs.stringify(data)),
  joinGroup: (params) => xhr.get(`${webloginBaseUrl}/joinGroup`, { params }),
  leaveGroup: (params) => xhr.get(`${webloginBaseUrl}/leaveGroup`, { params }),
  follow: (params) => xhr.get(`${webloginBaseUrl}/follow`, { params }),
  followQuery: (params) =>
    xhr.get(`${webloginBaseUrl}/followQuery`, { params }),
  broadcast: (data) =>
    xhr.post(`${webloginBaseUrl}/broadcast`, qs.stringify(data))
};
